import { render, staticRenderFns } from "./WithdrawalStatistics.vue?vue&type=template&id=6a718f7b&scoped=true"
import script from "./WithdrawalStatistics.vue?vue&type=script&lang=js"
export * from "./WithdrawalStatistics.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalStatistics.vue?vue&type=style&index=0&id=6a718f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a718f7b",
  null
  
)

export default component.exports